<div class="panel-container" [ngClass]="{'ets-hidden': !isActive}">
   <ag-grid-angular class="ag-theme-balham-dark" [gridOptions]="gridOptions"></ag-grid-angular>
</div>

<ets-symbol-picker-dialog 
      [isVisible]="this.isSymbolPickerVisible"
      (instrumentSelected)="this.onSymbolSelected($event)"
      (closed)="this.onSymbolPickerClosed()"></ets-symbol-picker-dialog>